import inflector from '@/lib/utils/Inflector'

inflector.rules('irregular', {
		'meta': 'meta',
		'data': 'data',
		'history': 'history',
		'sync': 'sync',
		'ID': 'id',
		'id': 'id',
		'media': 'media',
		'staff': 'staff',
		'menu': 'menu',
		'info': 'info',
		'termmeta': 'termmeta',
		'usermeta': 'usermeta',
		'postmeta': 'postmeta',
		'menus': 'menus',
		'store': 'store',
		'sort': 'sort',
		'portfolio': 'portfolio'
	}
)

inflector.rules('uninflected', [
	'portfolio','id','history','sync','meta','data','staff','menu','info','termmeta','usermeta','postmeta','menus','store','sort'
])

export const singularize = function (value= '') {
	return inflector.singularize(value)
}

export const titleize = (value= '') => {
	value = '' + value
	return value.toLowerCase().replaceAll(/(?:^|\s|-)\S/g, x => x.toUpperCase())
}

export const underscore = (value= '') => {
	return inflector.underscore(value)
}

export const classify = (value= '') => {
	return inflector.classify(underscore(value))
}

export const camelize = (value = '', uppercaseFirst = false, delimiter = '_') => {
	if (uppercaseFirst) {
		return inflector.camelize(value, delimiter)
	} else {
		return inflector.variable(value)
	}
}

export const capitalize = (value= '', titleCase) => {
	return inflector.humanize(value)
}

export const tableize = (value= '', titleCase) => {
	return inflector.tableize(value)
}

export const title = (value= '') => {
	return titleize(value.replaceAll('_', ' '))
}

export const pluralize = (value= '', titleCase) => {
	return inflector.pluralize(value)
}

export const dasherize = (value= '') => {
	return inflector.dasherize(value)
}

export const humanize = (value= '') => {
	return inflector.humanize(value)
}

export const uppercaseSplit = (value) => {
	return titleize(inflector.underscore(value).replaceAll('_', ' '))
}

export const toUpperCase = (value= '') => {
	return humanize(underscore(value)).replace("I D", "Id")
}

